module.exports = __webpack_public_path__ + "static/img/5areaA_10.f054613.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/5areaA_10.png
// module id = 820
// module chunks = 1